// On browser load (everytihing has downloaded and is ready have loaded)

function _90dl_isIE() {
	const sAgent = window.navigator.userAgent
	const Idx = sAgent.indexOf( "MSIE" )

	// If IE, return version number.
	if (Idx > 0) {
		return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)))
		// If IE 11 then look for Updated user agent string.
	} else if(!!navigator.userAgent.match(/Trident\/7\./)) {
		return true;
	} else {
		return false; //It is not IE
	}
}

window.onload = function() {
  'use strict';
  
  if(_90dl_isIE()) {
    let _html = document.getElementsByTagName('html')
    _html[0].classList.add('ie')
  }
  navScroll()


  window.addEventListener("scroll", function(e) {
   navScroll()
  });

  
  
  // let navigation = document.getElementById('menu-primary-navigation');
  // var children = Array.from(navigation.children)
  // console.log(navigation.children);
  
  // children.forEach(function(link) {
  //   let highlight_class = link.className.match(/\highlight-[^\s]*/);
  //   let nav_container = document.getElementsByClassName('sub-navigation')[0];
  //   link.addEventListener("mouseover", function() {
  //     nav_container.classList.add(highlight_class);
  //   });
  //   link.addEventListener("mouseout", function() {
  //     nav_container.classList.remove(highlight_class);
  //   });
  // });

  // Find all maps and initialize
  var maps = document.getElementsByClassName('acf-map'); 
  
    if (maps) {
  
      for (var i=0; i < maps.length; i++) {
  
        var zoom_level = parseInt(maps[i].dataset.zoom);
        var map_view = maps[i].dataset.mapType;
  
        var zoom_type = (maps[i].classList.contains('fit-to-boundries') ? "fit-to-boundries" : 'zoom-main-marker');
  
        var settings = {
          zoom:         zoom_level,
          zoom_type:    zoom_type, 
          map_type_id:  map_view
        }
        var google_map = new _90d_acf_google_map(settings);
        google_map.init();
  
        // Get all classes on map item and initialize additional features
        var maps_classes = maps[i].classList;
  
        mapFeaturesLoader(maps_classes, google_map);
      }  
    } 

};


function mapFeaturesLoader(maps_classes, google_map) {
  if(typeof google === 'undefined') {
    setTimeout(function() {
      mapFeaturesLoader(maps_classes, google_map);
    },1000);
  } else {
    for (var t=0; t < maps_classes.length; t++) {
      switch(maps_classes[t]) {
        case 'directions':
          google_map.directions_init();
          break;
      }          
    }
  }
}

/**
 * @function navScroll
 * @return {type} {description}
 */
function navScroll() {
  let _headerHeight = window.innerHeight * 0.3;
  let _header = document.getElementById("site_header");
  if(window.scrollY > _headerHeight) {
    _header.classList.add('active');
  } else {
    _header.classList.remove('active');
  }
}
